import * as React from 'react'

import { Link } from '@ally/metronome-ui'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { StyledTextBody } from '../Shared'
import { getAAOSForgotPasswordUrl, getAAOSForgotUsernameUrl } from '../../Utils'

const AutoLinkFailedMaxRetriesContent: React.FC = () => {
  const { hostServices } = useTransmit()

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Link Accounts:We Couldnt Link Your Accounts',
    })
  }, [])

  return (
    <>
      <LoginHeading title="We couldn't link your accounts." />

      <StyledTextBody size="sm" tag="p">
        You&apos;ve reached the maximum number of login attempts. Head back to{' '}
        <Link
          target="_blank"
          text="Ally Auto"
          href="https://www.ally.com/auto/online-services/access/pre-login.html"
          allytmln="allyAuto"
        />{' '}
        to recover your{' '}
        <Link
          target="_blank"
          text="username"
          href={getAAOSForgotUsernameUrl()}
          allytmln="forgotUsername"
        />{' '}
        and{' '}
        <Link
          target="_blank"
          text="password"
          href={getAAOSForgotPasswordUrl()}
          allytmln="forgotPassword"
        />
        .
      </StyledTextBody>
    </>
  )
}

export const AutoLinkFailedMaxRetries: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AutoLinkFailedMaxRetries') {
    return null
  }

  return <AutoLinkFailedMaxRetriesContent />
}
